import { useEffect, useRef } from 'react';
import { Container } from 'react-bootstrap';
import DocumentDetail from './DocumentDetail';
import './UploadDocument.scss';
import { Link } from 'react-router-dom';
import backArrowIcon from 'src/Admin/img/arrow_back.svg';

function ViewDocument() {
  const pageInfo = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (pageInfo && pageInfo.current) {
        pageInfo.current.focus();
      }
    }, 10);
  }, []);

  return (
    <div>
      <Container>
        <div
          className="sr-only"
          role="heading"
          aria-level={1}
          tabIndex={0}
          ref={pageInfo}
        >
          {' '}
          View Documents Page
        </div>
        <div className="d-flex align-items-center">
          <Link
            to={'/member/messages-documents-notifications'}
            state={{
              documentDetailBackButton: true,
              comingFrom: 'DashboardUploadIcon',
            }}
            className="redirect-arrow pt-3"
          >
            <img
              role="button"
              aria-label="Click to go to documents list page"
              tabIndex={0}
              src={backArrowIcon}
              alt="logo"
            />
          </Link>
          <div className="ml-3">
            <h1 className="content-header" aria-hidden={true}>
              View <span className="content-header-bold">Document(s)</span>
            </h1>
          </div>
        </div>
      </Container>
      <Container>
        <DocumentDetail />
      </Container>
    </div>
  );
}

export default ViewDocument;
